import React from "react";

export const GrtJsxTem = function(props){
    return(
        <div>
          我是jsx生成的组件4444

        </div>
    )
}
